import { useActivityStore } from '@stores/useActivityStore'
import { View, Text } from 'tamagui'
import { useMemo } from 'react'

export function ActivityDetails() {
  const { activity } = useActivityStore()

  const examQuestionsCount = activity?.examQuestionsCount || 0
  const retryCount = activity?.retryCount || 0
  const maxAttempts = activity?.maxAttempts || 0
  const minGrade = activity?.minGrade || 0

  const result = useMemo(() => {
    if (activity?.examAnswer?.score === 0) return '0'
    return activity?.examAnswer?.score.toFixed(2) || '-'
  }, [activity])

  return (
    <View gap="$spacing-inset-xs">
      <View
        backgroundColor="$neutral-100"
        padding="$spacing-inset-xs"
        borderRadius="$border-radius-lg"
      >
        <Text
          color="$neutral-800"
          fontSize="$font-size-xxxs"
          opacity={0.64}
          lineHeight={18}
        >
          QUANTIDADE DE QUESTÕES
        </Text>
        <Text
          color="$neutral-800"
          fontSize="$font-size-xs"
          fontWeight={600}
          lineHeight={24}
        >
          {examQuestionsCount}
        </Text>

        <View flexDirection="row" justifyContent="space-between" marginTop={20}>
          <View>
            <Text
              color="$neutral-800"
              fontSize="$font-size-xxxs"
              opacity={0.64}
              lineHeight={18}
            >
              TENTATIVAS
            </Text>
            <Text
              color="$neutral-800"
              fontSize="$font-size-xs"
              fontWeight={600}
              lineHeight={24}
            >
              {retryCount} de {maxAttempts} tentativas
            </Text>
          </View>

          <View>
            <Text
              color="$neutral-800"
              fontSize="$font-size-xxxs"
              opacity={0.64}
              lineHeight={18}
            >
              NOTA MÍNIMA
            </Text>
            <Text
              color="$neutral-800"
              fontSize="$font-size-xs"
              fontWeight={600}
              lineHeight={24}
            >
              {minGrade}
            </Text>
          </View>
        </View>
      </View>

      <View
        backgroundColor="$neutral-100"
        padding="$spacing-inset-xs"
        borderRadius="$border-radius-lg"
      >
        <Text
          color="$neutral-800"
          fontSize="$font-size-xxxs"
          opacity={0.64}
          lineHeight={18}
        >
          SEU RESULTADO
        </Text>
        <Text
          color="$neutral-800"
          fontSize="$font-size-xs"
          fontWeight={600}
          lineHeight={24}
        >
          {result}
        </Text>
      </View>
    </View>
  )
}
